import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-18",
  "use": "icon-button_icon-18-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-18\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M23 8v12a2 2 0 01-2 2H3a2 2 0 01-2-2V8\" /><path stroke-linecap=\"round\" d=\"M12 18.449l-3-3M15 15.449l-3 3\" /><path stroke-linejoin=\"round\" d=\"M6 2h12l5 6H1z\" /><path stroke-linecap=\"round\" d=\"M12 18v-7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol